import React, { useEffect, useState } from 'react';
import styles from './FaultedElement.module.css';
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';
import errorImage from "../../../../img/errorBigIcon.png";


const FaultedElement = ({ connector }) => {
    let lang = localStorage.getItem('language') === 'ru';
    const [showErrorText, setShowErrorText] = useState(lang ? localeRu["0x6_0x0"] : localeEn["0x6_0x0"]);

    useEffect(() => {
        let errorKey = `${connector?.error}`.trim();
        if (!errorKey) {
            errorKey = "0x6_0x0"; // default key if empty or undefined
        }
        errorKey = errorKey.replace(' ', '_'); // ensure format consistency
        setShowErrorText(lang ? localeRu[errorKey] : localeEn[errorKey]);
    }, [connector?.error, lang]);

    return (
        <div className={styles.parameters}>
            <p className={styles.titleText}>{lang ? localeRu.errorInfo : localeEn.errorInfo}</p>
            <div className={styles.imageBlock}>
                <img src={errorImage} alt="Error image" />
                <p className={styles.mainText}>{showErrorText}</p>
            </div>
        </div>
    )
}

export default FaultedElement;